import type React from 'react';
import styles from './index.module.scss';

import ClipLoader from 'react-spinners/ClipLoader';

export const Loading: React.FC = () => (
  <div className={styles.loading}>
    <ClipLoader color="#1847c7" size={50} />
  </div>
);
